import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aff-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss']
})
export class NotFoundPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
